module.exports = __webpack_public_path__ + "static/image 124-35d342a32bab0772d7595a4c84c2f0f9.jpg";